import { useEffect, useState } from "react";
import { Container, Row, Col, Form, Table } from "react-bootstrap";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import blogFetch from "../../axios/config";
import { FormatDate } from "../../utils/DataUtils";
import { StatusHse } from "./statusHse";

export const HistoricoHse = () => {
  const [historico, setHistorico] = useState([]);
  const [busca, setBusca] = useState("");

  useEffect(() => {
    blogFetch
      .get("/sga/history")
      .then((res) => setHistorico(res.data))
      .catch((err) => console.error(err));
  }, []);

  const termo = busca.toLowerCase();
  const filtrados = historico.filter((h) =>
    [h.acao, h.usuario, h.colaborador, h.empresa].some((v) => v?.toLowerCase().includes(termo))
  );

  return (
    <>
      <Sidebar />
      <Navbar />
      <Container fluid className="app_body py-4">
        <h3 className="fw-bold text-center mb-4">Histórico HSE</h3>

        <Row className="g-3 mb-4">
          <Col md={4}>
            <Form.Control
              type="search"
              placeholder="Buscar ação, usuário, colaborador ou empresa"
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
            />
          </Col>
        </Row>

        <div className="table-responsive" style={{ maxHeight: "650px" }}>
          <Table striped hover bordered className="align-middle text-center" style={{ minWidth: "1000px" }}>
            <thead className="table-dark sticky-top" style={{ zIndex: 10 }}>
              <tr>
                {["Data/Hora", "Usuário", "Ação", "Colaborador", "Empresa", "Status", "Motivo"].map((c) => (
                  <th key={c} className="text-nowrap">{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtrados.length ? (
                filtrados.map((h) => (
                  <tr key={h.id}>
                    <td className="text-nowrap">{FormatDate(h.dataHora)}</td>
                    <td>{h.usuario}</td>
                    <td>{h.acao}</td>
                    <td>{h.colaborador || "-"}</td>
                    <td>{h.empresa || "-"}</td>
                    <td className="text-nowrap">
                      {h.statusAnterior && <><StatusHse status={h.statusAnterior} /> → </>}
                      {h.novoStatus ? <StatusHse status={h.novoStatus} /> : "-"}
                    </td>
                    <td>{h.motivo || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="text-muted fst-italic">Nenhum registro encontrado.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Container>
    </>
  );
};
